import styles from "../LegalIdVerification.module.scss";
import { usePageView } from "../../../shared/analytics/usePageView";
import { DOCUMENT_CAPTURE_EVENTS, DOCUMENT_CAPTURE_SECTIONS } from "../../../shared/analytics/documentCaptureEvents";
import { isVeriffMobile } from "../../../shared/utils/veriffEnvironment";

/**
 * CaptureScreen (Veriff) — the mount point Veriff's own `createVeriffFrame({ embedded: true })`
 * attaches to (`#veriff-root`).
 *
 * The mobile check lives here, not in the parent's render condition: on mobile Veriff renders its
 * own modal and ignores `rootElementID`, so there is no container to render — but the capture
 * stage is still entered, and its Viewed still has to pair with the `document_capture_screen`
 * Outcome. Mounting unconditionally and rendering `null` on mobile keeps one owner of the event
 * and one mount, so it can't double-fire.
 */
export function CaptureScreen() {
  usePageView(DOCUMENT_CAPTURE_EVENTS.VIEWED.DOCUMENT_CAPTURE_SCREEN, "section", { section: DOCUMENT_CAPTURE_SECTIONS.DOCUMENT_CAPTURE });

  if (isVeriffMobile()) return null;

  return <div id="veriff-root" className={styles.veriffContainer} />;
}
